import styled from "styled-components";

export const HealthEnterWarningItem = styled.div`
  position: fixed;
  display: flex;
  width: 100%;
  padding: 10px;
  top: 56px;
  left: 0;
  background: ${(props) => props.theme.colors.black50};
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  flex-direction: column;
  gap: 4px;
  z-index: 90;
`;

export const ItemHeader = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.white100};
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: initial;
  line-height: 150%;
  gap: 6px;

  svg {
    path {
      fill: ${(props) => props.theme.colors.white100};
    }
  }
`;

export const ItemSubHeader = styled.div`
  font-size: 1rem;
  color: ${(props) => props.theme.colors.black60};
`;
